import React from 'react';

export default function Title({ content }) {
  return content ? <h1 className="title">{content}</h1> : null;
}
